<template>
  <grid :config="{searchFields: ['username', 'name', 'email']}" :data="users"
        class="u-1-of-1">
    <template v-slot:gridAdd>
      <router-link class="c-button c-button--secondary c-button--large c-button--icon" exact
                   :to="{ name: 'admin.user.add'}">
        <svg role="img" class="c-button__icon">
          <use xlink:href="images/svg-symbols.svg#plus-icon"></use>
        </svg>
        <span class="c-button__label">{{$t("user.add")}}</span>
      </router-link>
    </template>
    <template v-slot:gridHeader>
      <div class="o-layout c-list__row u-padding-horizontal-small">
        <div class="o-layout__item u-4-of-9-at-small">
          {{$t('name')}}
        </div>
        <div class="o-layout__item u-2-of-9-at-small">
          {{$t('username')}}
        </div>
        <div class="o-layout__item u-3-of-9-at-small">
          {{$t('email')}}
        </div>
      </div>
    </template>
    <template v-slot:gridData="{element}">
      <div class="o-layout__item u-4-of-9-at-small c-list__main-cell">
        <router-link class="c-list__link" :to="{ name: 'admin.user.view', params: { userId: element.id}}">
          {{element.name}}
        </router-link>
      </div>
      <div class="o-layout__item u-2-of-9-at-small">
        {{element.username}}
      </div>
      <div class="o-layout__item u-3-of-9-at-small">
        {{element.email}}
      </div>
    </template>
  </grid>
</template>

<script>
  import sortBy from 'lodash/sortBy'

  export default {
    name:'organisationList',
    components: {
      grid: require('client/components/dataGrid.vue').default,
    },
    computed: {
      countries: function() {
        return this.$store.state.countries.items
      },
      users: function() {
        return sortBy(this.$store.state.users.items, 'name')
      },
    },
    methods: {
    },
  }
</script>
